import type { ButtonProps } from "@mui/material/Button";
import type { FC } from "react";
import { AppButton } from "../../../../shared/components/AppButton";

export const AddModel: FC<ButtonProps> = ({ ...props }) => {
  return (
    <AppButton buttonType={"text"} {...props}>
      Добавьте модель для сравнения
    </AppButton>
  );
};